import { createIcon } from '@mote/ui/components/icon'
import { defaultProps } from './defaultProps'

export const BoltIcon = createIcon({
  displayName: 'BoltIcon',
  d: 'M11.117 21h-1l1-7h-3.5c-.58 0-.57-.32-.38-.66.19-.34.05-.08.07-.12 1.29-2.28 3.23-5.68 5.81-10.22h1l-1 7h3.5c.49 0 .56.33.47.51l-.07.15c-3.94 6.89-5.9 10.34-5.9 10.34Z',
  defaultProps: defaultProps
})
